$(document).ready(function() {
  if ($('#carousel').length) {
    $('#carousel').slick({
      autoplay: true,
      infinite: true,
      speed: 1000,
      fade: true,
      cssEase: 'linear',
      pauseOnHover: false,
      dots: true,
    });
  }
})
